import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";

// Admin bundle is code-split so public visitors never download it.
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const ProtectedRoute = lazy(() => import("@/components/admin/ProtectedRoute"));

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
          <BrowserRouter>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 0,
                color: "#fff",
              },
            }}
          />
        </ReactLenis>
      </AuthProvider>
    </div>
  );
}

export default App;
